<script setup lang="ts">
const route = useRoute()

const AVAILABLE_ROUTES = ['map', 'atms', 'branches']

if (!AVAILABLE_ROUTES.includes(String(route.params.slug))) {
  throw createError({ statusCode: 404 })
}
</script>

<template>
  <main class="flex h-full items-center justify-center">
    <div class="p-6">[file: pages/banks/[slug].vue, params: {{ route.params.slug || 'null' }}]</div>
  </main>
</template>
